 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0,
 		74: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0,
 		74: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~route-MapView~route-account~route-adminAdvertisements~route-adminAnnouncements~route-adminCa~106bae12","1":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~b21f9f2b","2":"route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCa~b10cace3","3":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","4":"vendors~route-MapView~route-account~route-album~route-habitat~route-highlights~route-home~route-myAl~b48cc60e","5":"route-account~route-feed~route-habitats~route-help~route-notifications~route-talkSchedule","7":"vendors~route-habitat~route-highlights~route-home","15":"route-MapView","16":"route-TermsAndPrivacy","17":"route-account","18":"route-adminAdvertisements","19":"route-adminAnnouncements","20":"route-adminCameraInfo","21":"route-adminCameraSettings","22":"route-adminConfigurations","23":"route-adminHabitats","24":"route-adminOnlineUsersInfo","25":"route-adminPartners","26":"route-adminPlaylists","27":"route-adminTestNewModelsForAiKeeper","28":"route-adminUsers","29":"route-album","30":"route-emailVerify","31":"route-feed","32":"route-gift","33":"route-habitat","34":"route-habitats","35":"route-help","36":"route-highlights","37":"route-home","38":"route-importBundleUsers","39":"route-login","40":"route-myAlbum","41":"route-notFound","42":"route-notifications","43":"route-partnerDonation","44":"route-passwordReset","45":"route-profile","46":"route-redeem","47":"route-reports","48":"route-schedule","49":"route-signup","50":"route-socialLogin","51":"route-softReload","52":"route-start","53":"route-talkSchedule","54":"route-welcome","55":"route-zoo"}[chunkId]||chunkId) + ".chunk." + {"0":"cef04","1":"a33f8","2":"60834","3":"81a6d","4":"a792e","5":"5e4d1","6":"3ca10","7":"157f7","8":"3bae9","9":"8ce5c","10":"52c62","11":"efab9","15":"fa94b","16":"67d82","17":"8639e","18":"d159f","19":"2c065","20":"6fc7f","21":"09f1e","22":"ad1cf","23":"498c2","24":"6fe0a","25":"40965","26":"c9768","27":"4ba45","28":"3a5cf","29":"6996f","30":"7a693","31":"33ae5","32":"07e2c","33":"a56d3","34":"808a9","35":"987ec","36":"b0050","37":"10424","38":"b848a","39":"a5e71","40":"a8261","41":"acfe5","42":"6ae83","43":"2c7f9","44":"43b05","45":"17a58","46":"689c5","47":"7c793","48":"853f1","49":"b36b9","50":"6463a","51":"faa4a","52":"499a7","53":"9418e","54":"a7912","55":"c8154","56":"995c6","57":"f3165","58":"972fe","59":"f037c","60":"f9af6","61":"d2427","62":"81a32","63":"77a49","64":"6cb16","65":"790ca","66":"3cd6e","67":"be2a3","68":"a3de2","69":"ff001","70":"5ab0e","71":"7ca65","72":"0f214","73":"4ad1c","75":"e48da","76":"5e4cc","77":"bea93","78":"9250e","79":"38002","80":"e8c0a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"5":1,"8":1,"10":1,"11":1,"15":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"25":1,"26":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"53":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"67":1,"68":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~route-MapView~route-account~route-adminAdvertisements~route-adminAnnouncements~route-adminCa~106bae12","1":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~b21f9f2b","2":"route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCa~b10cace3","3":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","4":"vendors~route-MapView~route-account~route-album~route-habitat~route-highlights~route-home~route-myAl~b48cc60e","5":"route-account~route-feed~route-habitats~route-help~route-notifications~route-talkSchedule","7":"vendors~route-habitat~route-highlights~route-home","15":"route-MapView","16":"route-TermsAndPrivacy","17":"route-account","18":"route-adminAdvertisements","19":"route-adminAnnouncements","20":"route-adminCameraInfo","21":"route-adminCameraSettings","22":"route-adminConfigurations","23":"route-adminHabitats","24":"route-adminOnlineUsersInfo","25":"route-adminPartners","26":"route-adminPlaylists","27":"route-adminTestNewModelsForAiKeeper","28":"route-adminUsers","29":"route-album","30":"route-emailVerify","31":"route-feed","32":"route-gift","33":"route-habitat","34":"route-habitats","35":"route-help","36":"route-highlights","37":"route-home","38":"route-importBundleUsers","39":"route-login","40":"route-myAlbum","41":"route-notFound","42":"route-notifications","43":"route-partnerDonation","44":"route-passwordReset","45":"route-profile","46":"route-redeem","47":"route-reports","48":"route-schedule","49":"route-signup","50":"route-socialLogin","51":"route-softReload","52":"route-start","53":"route-talkSchedule","54":"route-welcome","55":"route-zoo"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","1":"31d6c","2":"31a72","3":"31d6c","4":"31d6c","5":"9d452","6":"31d6c","7":"31d6c","8":"18e4e","9":"31d6c","10":"37e29","11":"4cd1c","15":"205a3","16":"31d6c","17":"82a28","18":"197d1","19":"197d1","20":"197d1","21":"54271","22":"197d1","23":"abe1c","24":"31d6c","25":"5acf9","26":"197d1","27":"31d6c","28":"06749","29":"02330","30":"18823","31":"63204","32":"00bc0","33":"726b1","34":"26175","35":"d88c6","36":"6a05e","37":"63b98","38":"31d6c","39":"18823","40":"511bd","41":"5318a","42":"63204","43":"63204","44":"18823","45":"8c877","46":"a3247","47":"576ae","48":"0e77d","49":"18823","50":"31d6c","51":"31d6c","52":"31d6c","53":"f5a47","54":"31d6c","55":"67e00","56":"df059","57":"3f8cb","58":"fa475","59":"429d0","60":"c51fe","61":"1fa4d","62":"b2ca4","63":"f3859","64":"31d6c","65":"31d6c","66":"31d6c","67":"91a66","68":"756f3","69":"31d6c","70":"31d6c","71":"31d6c","72":"31d6c","73":"31d6c","75":"31d6c","76":"31d6c","77":"31d6c","78":"31d6c","79":"31d6c","80":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "brot");
